
import Component from "vue-class-component";
import Vue, { CreateElement, VNode } from "vue";
import { CheckAuthorities } from "@/lib/helpers/componentViewController/decorators";
import { Prop } from "vue-property-decorator";

@Component({ name: "WrapperCheckAuthorities" })
export default class WrapperCheckAuthorities extends Vue {
  @Prop({ type: String, required: true })
  public readonly ruleName!: string;

  @Prop({ type: String, required: true })
  public readonly authRuleKey!: string;

  @CheckAuthorities(ctx => ctx.ruleName, ctx => ctx.authRuleKey)
  public allowRender!: boolean;

  private render(h: CreateElement): VNode {
    if (!this.allowRender) return h();
    const component =
      this.$scopedSlots.default && this.$scopedSlots.default({});
    if (component && component.length === 1) return component[0];
    return h("span", {}, component);
  }
}
